module.exports = __webpack_public_path__ + "img/es.ec327047.svg";